import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { t } from '../../i18n/nl.js';
import { fmtDate } from '../../utils/formatUtils.js';

function statusInfo(m) {
  const today = new Date().toISOString().slice(0, 10);
  const reactivatedAfterCancel = !!m.reactivated_at
    && (!m.cancellation_date || new Date(m.reactivated_at) > new Date(m.cancelled_at));

  if (reactivatedAfterCancel) {
    return { label: t('opzeggingen.statusHeractiveerd', { datum: fmtDate(m.reactivated_at) }), className: 'badge-active' };
  }
  if (m.cancellation_date && m.cancellation_date >= today) {
    return { label: t('opzeggingen.statusNogLopend', { datum: fmtDate(m.cancellation_date) }), className: 'badge-inactive' };
  }
  return { label: t('opzeggingen.statusDefinitiefVerlopen'), className: 'badge-inactive' };
}

export default function OpzeggingenPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    setError('');
    try {
      const { data, error: err } = await supabase
        .from('client_memberships')
        .select(`
          id, cancellation_date, cancellation_reason, cancelled_at, reactivated_at,
          is_custom, custom_name,
          client:profiles!client_memberships_client_id_fkey(id, full_name),
          membership_type:membership_types(name)
        `)
        .not('cancelled_at', 'is', null)
        .order('cancelled_at', { ascending: false });

      if (err) throw err;
      setRows(data || []);
    } catch (err) {
      setError(t('opzeggingen.foutLaden') + err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">{t('opzeggingen.title')}</h1>
          <p className="page-subtitle">{rows.length} {t('opzeggingen.aantalGevonden')}</p>
        </div>
      </div>

      {error && <div className="error-msg" style={{ marginBottom: 20 }}>{error}</div>}

      {loading ? (
        <div className="loading-center"><div className="spinner" /></div>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>{t('opzeggingen.colClient')}</th>
                  <th>{t('opzeggingen.colType')}</th>
                  <th>{t('opzeggingen.colOpzegdatum')}</th>
                  <th>{t('opzeggingen.colReden')}</th>
                  <th>{t('opzeggingen.colEinddatum')}</th>
                  <th>{t('opzeggingen.colStatus')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={6}>
                      <div className="empty-state">
                        <div style={{ fontSize: 32 }}>📋</div>
                        <p>{t('opzeggingen.geenOpzeggingen')}</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map(m => {
                    const status = statusInfo(m);
                    const typeName = m.is_custom && m.custom_name ? m.custom_name : (m.membership_type?.name || t('opzeggingen.onbekend'));
                    return (
                      <tr key={m.id}>
                        <td>
                          {m.client?.id ? (
                            <Link to={`/coach/clients/${m.client.id}`} className="font-medium">
                              {m.client.full_name || '—'}
                            </Link>
                          ) : (m.client?.full_name || '—')}
                        </td>
                        <td className="text-muted">{typeName}</td>
                        <td className="text-muted">{fmtDate(m.cancelled_at)}</td>
                        <td className="text-muted">{m.cancellation_reason || t('opzeggingen.geenReden')}</td>
                        <td className="text-muted">{m.cancellation_date ? fmtDate(m.cancellation_date) : '—'}</td>
                        <td><span className={`badge ${status.className}`}>{status.label}</span></td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
